<template>
  <div class="activityFile common_group">
    <div class="title">
      <span>{{ $t('file.xa') }}</span>
    </div>
    <div class="wrapper">
      <div class="upload-wapper">
        <el-upload class="upload" :action="baseUrl" :before-upload="beforeUpload" :on-success="handleSuccess"
                   :on-progress="uploadVideoProcess" multiple :disabled="uploadDisable" :show-file-list="false"
        >
          <div>
            <el-button type="primary" :disabled="uploadDisable"><i class="iconfont icon-shangchuan-icon1" />{{ $t('file.ctu') }}</el-button>
            <span slot="tip" style="margin-left: 10px;">{{ $t('file.F10M') }}</span>
          </div>
        </el-upload>
        <el-button type="primary" class="dwonLoad" @click="fileDownload">
          <i class="iconfont icon-shangchuan-icon" />
          {{ $t('general.Download') }}
        </el-button>
      </div>

      <!-- <ul class="fileList">
        <li v-for="(item, index) in fileList" :key="index">
          <i class="iconfont icon-a-fujian-iconkaobei" />
          <span class="fileName">{{ item.name }}</span>
          <i class="iconfont icon--s-guanbi closeIconFont" v-show="!progressFlag && type !== 'new' && buttonType === $t('btn.Submit')" @click="beforeRemove(index)" />
          <el-button v-if="buttonType !== $t('btn.Submit') && type !== 'new'" type="primary" class="dwonLoad" @click="fileDownloadBtn(item)">
            <i class="iconfont icon-shangchuan-icon" />
            {{ $t('general.Download') }}
          </el-button>
          <el-progress class="progress" v-if="index === fileList.length - 1 && progressFlag" :percentage="loadProgress" />
        </li>
      </ul> -->
      <el-table
        border
        :data="fileList"
        style="width: 100%;text-align: center;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />
        <el-table-column
          prop="name"
          :label="$t('file.fileName')"
        >
          <template slot-scope="scope">
            <span class="fileName">{{ scope.row.fileName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('general.Operation')"
          width="130px"
          align="center"
        >
          <template slot-scope="scope">
            <div class="btn-box">
              <el-button type="text" size="small" :disabled="uploadDisable" @click="beforeRemove(scope.$index, scope.row)">{{ $t('btn.Delete') }}</el-button>
              <!-- <el-button type="text" size="small" @click="fileDownloadBtn(scope.row)">{{ $t('general.Download') }}</el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { activityQueryDetails, activistyCostAttribution } from '@/views/activitieList/service';
// import { drafts } from '@/views/activitieList/service';

export default {
  data () {
    return {
      loadProgress: 0,
      progressFlag: false,
      btnDisabled: false,
      fileList: [],
      baseUrl: window._env_.VUE_APP_FILESERVICE_URL, // 'https://fileserviceoutside.ruijie.com.cn/api/file/marketActivity/15008559650934784/15008559650934784'
      selectList: [],
      selectDownLoadList: [],
      uploadDisable: false
    };
  },
  props: {
    echoData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    echoData: {
      immediate: true,
      deep: true,
      handler (newVal) {
        this.uploadDisable = newVal.mactExpenseBelongVOList.every(item => {
          const { stat } = item.mactExpenseBelong;
          return stat === 60;
        });
      }
    }
  },
  methods: {
    getFileListCommand () {
      const { activityCode } = this.$route.query;
      const params = {
        activityCode,
        fileType: 'FeedBack'
      };
      activityQueryDetails.getFileList(params).then(res => {
        const { status, data } = res;
        if (status === '200') {
          this.fileList = data;
        }
      });
    },
    handleSelectionChange (e) {
      this.selectList = e;
    },
    fileDownload () {
      this.selectDownLoadList = [];
      this.selectList.forEach(item => {
        this.fileDownloadBtn(item);
      });
    },
    fileDownloadBtn (item) {
      activityQueryDetails.getDownloadUrl(item.fileId).then(res => {
        if (res.status === '200') {
          this.selectDownLoadList.push({
            fileName: item.fileName,
            url: res.data
          });
          // 调用批量下载
          this.batchDownload(this.selectDownLoadList);
        }
      });
      // const fileList = [
      //     { url: 'http://fileservicetest.ruijie.com.cn/api/file/marketActivity/16752756025921536?Token=eyJhbGciOiJIUzI1NiJ9.eyJGU0NsYWltIjoie1wiZmlsZUlkc1wiOltdLFwicGFyYW1cIjp7fSxcImNhdGFsb2dJZHNcIjpbXCIxNTAwODU1OTY1MDkzNDc4NFwiXSxcInBvb2xJZHNcIjpbXCIxNTAwODU1OTY1MDkzNDc4NFwiXX0iLCJpc3MiOiJtYXJrZXRBY3Rpdml0eSIsImF1ZCI6IlJ1amllLkZpbGVTZXJ2aWNlIiwiZXhwIjoxNzEwMzk5MDYyfQ.khIkviZtzygpSB_Pf5h0Kt7iiJutvExdfnsnKCOjw0E', filename: '同步生产的路径 - 副本.txt' },
      //     { url: 'http://fileservicetest.ruijie.com.cn/api/file/marketActivity/16752755812356096?Token=eyJhbGciOiJIUzI1NiJ9.eyJGU0NsYWltIjoie1wiZmlsZUlkc1wiOltdLFwicGFyYW1cIjp7fSxcImNhdGFsb2dJZHNcIjpbXCIxNTAwODU1OTY1MDkzNDc4NFwiXSxcInBvb2xJZHNcIjpbXCIxNTAwODU1OTY1MDkzNDc4NFwiXX0iLCJpc3MiOiJtYXJrZXRBY3Rpdml0eSIsImF1ZCI6IlJ1amllLkZpbGVTZXJ2aWNlIiwiZXhwIjoxNzEwMzk5MDYyfQ.khIkviZtzygpSB_Pf5h0Kt7iiJutvExdfnsnKCOjw0E', filename: 'isp.zip' }
      //     // 更多文件
      // ];
      // // 调用批量下载
      // this.batchDownload(fileList);
    },
    batchDownload (files) {
        files.forEach((file, index) => {
            // 延迟执行以避免浏览器阻止弹窗
            setTimeout(() => {
                // 创建临时的<a>元素用于下载
                const link = document.createElement('a');
                link.href = file.url;
                link.download = file.fileName || 'file' + index;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }, index * 1000); // 每个文件下载间隔1秒
        });
    },
    validateHandler () {
      let result = true;
      if (this.fileList.length > 0) {
        let messageInfo = '';
        result = this.fileList.every(item => {
          if (!((item.response && item.response.data[0].FID) || item.fileId)) {
            messageInfo = item.name ? `${item.name} ${this.$t('file.FPdar')}` : this.$t('file.FPdaua');
          }
          return (item.response && item.response.data[0].FID) || item.fileId;
        });
        if (!result) this.$message.error(messageInfo);
      }
      return result;
    },
    beforeUpload (file) {
      return new Promise((resolve, reject) => {
        let fileSize = file.size / 1024 / 1024 < 10;
        if (!fileSize) {
          this.$message.error(this.$t('file.uFn10M'));
          reject(new Error(this.$t('file.uFn10M')));
          return false;
        }
        newApplicationFormApi.getFileToken().then(res => {
          if (res.status === '200') {
            if (this.baseUrl.indexOf('?Token=') < 0) {
              this.baseUrl = this.baseUrl + '?Token=' + res.data;
            }
            this.loadProgress = 0;
            resolve();
          } else {
            reject(res.status);
          }
        });
      });
    },
    uploadVideoProcess (event, file, fileList) {
      this.progressFlag = true;
      if (event.percent >= 100) {
        let interval = setInterval(() => {
          this.loadProgress += 20;
          if (this.loadProgress >= 99) {
            this.loadProgress = 99;
            clearInterval(interval);
          }
        }, 100);
      }
    },
    handleSuccess (response, file, fileList) {
      if (response.status === '200' && response.data[0].FID) {
        this.loadProgress = 100;
        setTimeout(() => {
          this.progressFlag = false;
        }, 800);
        const fileList = [
          {
            fileId: response.data[0].FID,
            fileName: response.data[0].FullName,
            activityCode: this.$route.query.activityCode,
            sourceType: 'FeedBack'
          }
        ];
        activistyCostAttribution.saveFinancialFile(fileList).then(res => {
          if (res.status !== '200') {
            this.$message.error(this.$t('file.Fuf'));
          } else if (res.status === '200') {
            this.$message.success(this.$t('file.Fus'));
            this.getFileListCommand();
          }
        }).catch(err => {
          this.$message.error(this.$t('file.Fuf'), err);
        });
      } else {
        this.fileList.splice(this.fileList.length - 1, 1);
        this.progressFlag = false;
        this.$message.error(response.err);
      }
      this.baseUrl = this.baseUrl.split('?Token')[0];
    },
    beforeRemove (index, item) {
      activityQueryDetails.deleteFile(item.id).then(res => {
        const { status } = res;
        if (status === '200') {
          this.$message.success(this.$t('file.Fds'));
          this.getFileListCommand();
        }
      });
      // this.fileList.splice(index, 1);
    }
  },
  mounted () {
    this.getFileListCommand();
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common.scss';

.activityFile {
  >.wrapper {
    background: #FCFDFE;
    border: 1px solid #DEE1E7;
    line-height: 30px;
    position: relative;
    @extend .clear;

    &:before {
      content: '';
      background: #FFFFFF;
      width: 100%;
      height: 1px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .upload-wapper{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 70px;
      .upload{
        margin: 0 20px;
      }
      .dwonLoad{
        margin-right: 20px;
      }
      .fileName{
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .btn-box{
      display: flex;
      align-items: center;
      justify-content: center;
      .el-button{
        min-width:30px;
      }

    }
    >ul {
      >li {
        padding: 10px 0 10px 15px;
        min-height:50px;
        display: flex;
        align-items: center;
        border-top: 1px solid #E2E4E9;
        box-sizing: content-box;
        position: relative;

        >i:first-child {
          font-size: 18px;
          margin-right: 15px;
          color: #B8B8B8;
        }

        >span {
          margin-right: 40px;
        }

        >.closeIconFont {
          display: none;
          vertical-align: middle;
          font-size: 16px;
          cursor: pointer;
          color: #dc5650;
        }

        &:hover>.closeIconFont {
          display: inline-block;
        }

        >.el-progress {
          width: 300px;
          display: inline-block;
        }
        .progress{
          position: absolute;
          bottom: 3px;
        }
      }
    }

    ::v-deep>.upload {
      >.el-upload {
        padding: 20px;

        >div>span {
          margin-left: 10px;
          color: #5B646E;
        }
      }
    }
  }
}
</style>